<template>
  <div>
    <div class="wind-direction">
      <div class="wind-circle">
        <div class="wind-cross"></div>
        <!-- 16方位のチェックボックス -->
        <div
          v-for="direction in windDirections"
          :key="direction.value"
          class="wind-checkbox"
          :style="direction.style"
        >
          <input
            type="checkbox"
            :id="`wind-${direction.value.toLowerCase()}`"
            :value="direction.value"
            v-model="selectedWindDirections"
          />
        </div>
      </div>
      <!-- 方位ラベル -->
      <div class="wind-label north">北</div>
      <div class="wind-label south">南</div>
      <div class="wind-label east">東</div>
      <div class="wind-label west">西</div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedWindDirections: [],
    windDirections: [
      {
        value: "N",
        style: "top:10px; left:50%;",
        filterStyle: "top:10px; left:50%;"
      },
      {
        value: "NNE",
        style: "top:17px; left:73%;",
        filterStyle: "top:17px; left:73%;"
      },
      {
        value: "NE",
        style: "top:35px; left:90%;",
        filterStyle: "top:35px; left:90%;"
      },
      {
        value: "ENE",
        style: "top:58px; left:97%;",
        filterStyle: "top:58px; left:97%;"
      },
      {
        value: "E",
        style: "top:80px; left:100%;",
        filterStyle: "top:80px; left:104%;"
      },
      {
        value: "ESE",
        style: "top:102px; left:97%;",
        filterStyle: "top:102px; left:97%;"
      },
      {
        value: "SE",
        style: "top:125px; left:90%;",
        filterStyle: "top:125px; left:90%;"
      },
      {
        value: "SSE",
        style: "top:143px; left:73%;",
        filterStyle: "top:143px; left:73%;"
      },
      {
        value: "S",
        style: "top:150px; left:50%;",
        filterStyle: "top:150px; left:50%;"
      },
      {
        value: "SSW",
        style: "top:143px; left:27%;",
        filterStyle: "top:143px; left:27%;"
      },
      {
        value: "SW",
        style: "top:125px; left:10%;",
        filterStyle: "top:125px; left:10%;"
      },
      {
        value: "WSW",
        style: "top:102px; left:3%;",
        filterStyle: "top:102px; left:3%;"
      },
      { value: "W", style: "top:80px;", filterStyle: "top:80px; left:0%;" },
      {
        value: "WNW",
        style: "top:58px; left:3%;",
        filterStyle: "top:58px; left:3%;"
      },
      {
        value: "NW",
        style: "top:35px; left:10%;",
        filterStyle: "top:35px; left:10%;"
      },
      {
        value: "NNW",
        style: "top:17px; left:27%;",
        filterStyle: "top:17px; left:27%;"
      }
    ]
  }),
  methods: {
    getSelectDirection() {
      return this.selectedWindDirections;
    }
  }
};
</script>
